import React, { useState, useEffect } from 'react';
import { Paper, Grid, Button, makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { getItem } from '../../utils/LocalStorageUtil';
import { TOKEN_KEY } from '../../utils/StorageKeys';
import { login, loginSuccess, getUserInfo } from '../../store/authentication/actions';
import { loginData, loginError, isLogging, userInfoData, userInfoError } from '../../store/authentication/reducer';
import { InputGroup } from '../../components/common/input/input';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Logo from '../../assets/images/logo-b.png';
import { Link } from "react-router-dom";
import * as Constant from "../../utils/Constant";
import { useTranslation } from "react-i18next";
var Login = function (props) {
    var classes = useStyles();
    var history = useHistory();
    var _a = useState(""), username = _a[0], setUsername = _a[1];
    var _b = useState(""), password = _b[0], setPassword = _b[1];
    var t = useTranslation().t;
    useEffect(function () {
        var token = getItem(TOKEN_KEY);
        if (token) {
            history.push("/dashboard");
        }
        document.title = t("page.login") + Constant.APP_NAME;
        return function () {
            props.dispatch(loginSuccess(null));
        };
    }, []);
    useEffect(function () {
        if (props.loginData) {
            var user = props.loginData;
            if (user) {
                props.dispatch(getUserInfo(user.id));
            }
            else {
                history.push("/dashboard?tab=DEFAULT");
            }
        }
    }, [props.loginData]);
    useEffect(function () {
        if (props.userInfoData || props.getUserInfoError) {
            history.push("/dashboard?tab=DEFAULT");
        }
    }, [props.userInfoData, props.getUserInfoError]);
    var onSubmitLogin = function (event) {
        event.preventDefault();
        if (username && password) {
            props.dispatch(login({ username: username, password: password }));
        }
    };
    return (React.createElement("div", { className: classes.containerLogin },
        React.createElement(Grid, { container: true, spacing: 0, alignItems: "center", justify: "center" },
            React.createElement(Grid, { item: true, xs: 3 },
                React.createElement("div", { className: classes.loginLogo },
                    React.createElement("img", { className: classes.logo, src: Logo, alt: "logo" })),
                React.createElement("h3", { className: classes.loginTitle }, "Pubdesk Dashboard"),
                React.createElement(Paper, { className: classes.wraperLogin },
                    React.createElement("div", null,
                        props.loginError && React.createElement(Alert, { severity: "error" }, props.loginError.message || "Login Failed."),
                        React.createElement(Grid, { container: true, alignItems: "flex-end", className: classes.input },
                            React.createElement(InputGroup, { type: "text", iconName: "person", placeholder: "Username", value: username, onChange: function (text) { return setUsername(text); } })),
                        React.createElement(Grid, { container: true, alignItems: "flex-end", className: classes.input },
                            React.createElement(InputGroup, { type: "password", iconName: "vpn_key", placeholder: "Password", value: password, onChange: function (text) { return setPassword(text); }, onPressEnter: onSubmitLogin })),
                        React.createElement(Grid, { container: true, alignItems: "center", justify: "space-between", className: classes.input },
                            React.createElement(Grid, { item: true },
                                React.createElement(Link, { to: {
                                        pathname: "/forgot-password",
                                    }, className: classes.forgotPasswordBtn }, "Forgot password ?")),
                            React.createElement(Grid, { item: true },
                                React.createElement(Button, { variant: "contained", color: "primary", disabled: !username || !password, onClick: onSubmitLogin, style: { textTransform: "none" } }, "Login")))))))));
};
var useStyles = makeStyles(function (theme) { return ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    containerLogin: {
        marginRight: 'auto',
        marginLeft: 'auto',
        paddingLeft: 12,
        paddingRight: 12
    },
    loginLogo: {
        margin: '100px auto 50px',
        textAlign: 'center'
    },
    logo: {
        width: '100%'
    },
    loginTitle: {
        color: '#90a4ae',
        textAlign: 'center',
        marginTop: 16,
        marginBottom: 16,
        fontFamily: "'Open Sans', 'Droid Sans', Tahoma, Arial, sans-serif",
        fontSize: 24,
        fontWeight: 400
    },
    forgotPasswordBtn: {
        color: "#3f51b5",
        textDecoration: "none"
    },
    wraperLogin: {
        padding: '20px 20px 35px 20px'
    },
    input: {
        padding: 10
    },
    labelInput: {
        fontSize: 14
    },
    icon: {
        color: '#455A64'
    }
}); });
function mapStateToProps(state) {
    return {
        loginData: loginData(state),
        loginError: loginError(state),
        isLogging: isLogging(state),
        userInfoData: userInfoData(state),
        getUserInfoError: userInfoError(state),
    };
}
export default connect(mapStateToProps)(Login);
